import React, { useState } from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import CustomSelect from '../../../../core/common/commonSelect'
import { BannerSelect } from '../../../../core/common/selectOption/json/selectOption'
import { Link, useNavigate } from 'react-router-dom'
import Slider from 'react-slick'
import { all_routes } from '../../../router/all_routes'

const Banner = () => {

    const topCountries = [
        {
            name: 'Australia',
            value: 'AU'
        },
        {
            name: 'Canada',
            value: 'CA'
        },
        {
            name: 'Germany',
            value: 'DE'
        },
        {
            name: 'Ireland',
            value: 'IE'
        },
        {
            name: 'United States',
            value: 'US'
        },
        {
            name: 'United Kingdom',
            value: 'GB'
        }
    ];

    const [searchTerm, setSearchTerm] = useState<string>('');
    const [destination, setDestination] = useState<string>('CA');

    const route = all_routes
    const navigate = useNavigate();
    const handleSubmit = (event: React.FormEvent) => {

        event.preventDefault();
        const params = new URLSearchParams();
        params.append('searchTerm', searchTerm);
        params.append('destination', destination);
        const Path = `${route.allProgramsGrid}?${params.toString()}`;
        navigate(Path);
    };

    const bannerslider = {
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            {/* Home Banner */}
            <section className="home-slide-five">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-5 col-lg-6 col-12">
                            <div className="home-slide-five-face" data-aos="fade-down">
                                {/* Banner Text */}
                                <div className="home-slide-five-text">
                                    <h1 className="text-white mb-4">
                                        Break Limits. Go Global.
                                    </h1>
                                    <span className="text-warning d-inline-flex fw-semibold mb-3">
                                        Join 1,500+ top universities and colleges worldwide. Dominate your application process with a 95% success rate. Your future isn’t waiting—take it with Insta Admissions!
                                    </span>
                                </div>
                                {/* /Banner Text */}
                                {/* banner Seach Category */}
                                <div className="banner-content-five">
                                    <form onSubmit={handleSubmit} className="form">
                                        <div className="form-inner-five">
                                            <div className="input-group">
                                                {/* Slect Category */}
                                                <span className="drop-detail-five">
                                                    <CustomSelect
                                                        options={BannerSelect}
                                                        className="select d-flex"
                                                        placeholder="Select"
                                                        name='destination'
                                                        value={destination}
                                                        onChange={(selectedOption) => {
                                                            setDestination(String(selectedOption.value))
                                                        }}
                                                    />
                                                </span>
                                                {/* Slect Category */}
                                                {/* Search */}
                                                <input
                                                    type="text"
                                                    name="searchTerm"
                                                    value={searchTerm}
                                                    onChange={(e) => {setSearchTerm(e.target.value)}}
                                                    className="form-control"
                                                    placeholder="Search for programs"
                                                />
                                                {/* Search */}
                                                {/* Submit Button */}
                                                <button className="btn btn-primary sub-btn" type="submit">
                                                    <span>
                                                        <i className="fa-solid fa-magnifying-glass" />
                                                    </span>
                                                </button>
                                                {/* Submit Button */}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-12">
                            <div className="banner-six-img">
                                <div className="row">
                                    <div className="col-lg-6 align-self-end">
                                        <div className="ban-img-1" data-aos="fade-up">
                                            <ImageWithBasePath src="./assets/img/hero/hero-7.png" alt="img" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ban-img-2" data-aos="fade-down">
                                            <ImageWithBasePath
                                                className="ban-shape2"
                                                data-aos="fade-down"
                                                data-aos-delay={250}
                                                src="./assets/img/shapes/dot-group.png"
                                                alt="img"
                                            />
                                            <ImageWithBasePath
                                                className="ban-shape3"
                                                data-aos="fade-down"
                                                data-aos-delay={300}
                                                src="./assets/img/banner/ban-shape-2.svg"
                                                alt="img"
                                            />
                                            <ImageWithBasePath
                                                className="ban-shape4"
                                                data-aos="fade-down"
                                                data-aos-delay={350}
                                                src="./assets/img/banner/ban-shape-3.svg"
                                                alt="img"
                                            />
                                            <ImageWithBasePath src="./assets/img/hero/hero-8.png" alt="img" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="vector-shapes-five d-none d-lg-flex">
                        <ImageWithBasePath src="assets/img/bg/banner-vector.svg" alt="Img" />
                    </div>
                </div>
            </section>
            {/* /Home Banner */}
            {/* Leading Companies */}
            <section className="leading-section-five">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-6" data-aos="fade-down">
                            <div className="leading-five-content course-count">
                                <h3 className="mb-2">
                                    Trusted By <span className="counterUp">500</span>+
                                </h3>
                                <p>Leading Universities And Companies</p>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6" data-aos="fade-down">
                            <div className="lead-group-five">
                                <Slider {...bannerslider} className="leading-slider-five">
                                    <div className="item">
                                        <div className="lead-img">
                                            <ImageWithBasePath
                                                className="img-fluid"
                                                alt="Img"
                                                src="assets/img/client/client-28.svg"
                                            />
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="lead-img">
                                            <ImageWithBasePath
                                                className="img-fluid"
                                                alt="Img"
                                                src="assets/img/client/client-29.svg"
                                            />
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="lead-img">
                                            <ImageWithBasePath
                                                className="img-fluid"
                                                alt="Img"
                                                src="assets/img/client/client-30.svg"
                                            />
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="lead-img">
                                            <ImageWithBasePath
                                                className="img-fluid"
                                                alt="Img"
                                                src="assets/img/client/client-31.svg"
                                            />
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="lead-img">
                                            <ImageWithBasePath
                                                className="img-fluid"
                                                alt="Img"
                                                src="assets/img/client/client-32.svg"
                                            />
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="lead-img">
                                            <ImageWithBasePath
                                                className="img-fluid"
                                                alt="Img"
                                                src="assets/img/client/client-30.svg"
                                            />
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="lead-img">
                                            <ImageWithBasePath
                                                className="img-fluid"
                                                alt="Img"
                                                src="assets/img/client/client-31.svg"
                                            />
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* /Leading Companies */}
        </>

    )
}

export default Banner
